import { render, staticRenderFns } from "./AuthorizationRuleTable.vue?vue&type=template&id=7db97491&"
import script from "./AuthorizationRuleTable.vue?vue&type=script&lang=js&"
export * from "./AuthorizationRuleTable.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationRuleTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports